// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-modal {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.address-modal__backdrop {
  position: absolute;
  inset: 0;
  border: none;
  background: rgba(78, 63, 58, 0.45);
  cursor: pointer;
}

.address-modal__suggestions {
  list-style: none;
  margin: 0 0 0.75rem;
  padding: 0;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  overflow: hidden;
}

.address-modal__suggestion {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.75rem;
  border: none;
  background: #faf8f6;
  cursor: pointer;
  font: inherit;
}

.address-modal__suggestion:hover {
  background: #f0ebe6;
}

  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e8e4df;

.address-modal__delivery-restaurants .cart__restaurant-sort-hint {
  margin-bottom: 14px;
}

.address-modal__panel {
  position: relative;
  z-index: 1;
  width: min(560px, 100%);
  max-height: min(90vh, 720px);
  overflow: auto;
  background: #fff;
  border: 2px solid #a78c83;
  border-radius: 24px;
  padding: 1rem 1.25rem 1.25rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.address-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.address-modal__title {
  margin: 0;
  font-family: 'Neucha', cursive;
  font-size: 1.5rem;
  font-weight: 400;
  color: #4e3f3a;
}

.address-modal__close {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #4e3f3a;
}

.address-modal__warn,
.address-modal__hint,
.address-modal__empty {
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  margin: 0 0 0.5rem 0;
}

.address-modal__warn {
  color: #991b1b;
}

.address-modal__hint {
  color: #6b5d58;
}

.address-modal__hint--compact {
  margin-top: 0.65rem;
  margin-bottom: 0.35rem;
  font-weight: 500;
}

.address-modal__list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
  max-height: 200px;
  overflow: auto;
}

.address-modal__row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  width: 100%;
  text-align: left;
  padding: 0.55rem 0.65rem;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  background: #fff;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  color: #4e3f3a;
  cursor: pointer;
}

.address-modal__row:hover {
  background: #faf7f4;
}

.address-modal__row--active {
  border-color: #ff9702;
  background: #fff8ed;
}

.address-modal__row-text {
  font-weight: 500;
}

.address-modal__row-meta {
  font-size: 0.75rem;
  color: #6b5d58;
}

.address-modal__badge {
  font-size: 0.75rem;
  color: #6b5d58;
}

.address-modal__field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.65rem;
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  color: #4e3f3a;
}

.address-modal__field select,
.address-modal__field textarea {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  padding: 0.5rem 0.65rem;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  background: #fff;
  color: #4e3f3a;
}

.address-modal__field textarea {
  resize: vertical;
  min-height: 52px;
}

.address-modal__secondary {
  margin-bottom: 0.75rem;
  padding: 0.45rem 0.75rem;
  border: 1px solid #a78c83;
  border-radius: 12px;
  background: #f3e3cc;
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  cursor: pointer;
  color: #4e3f3a;
}

.address-modal__secondary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.address-modal__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.address-modal__cancel {
  padding: 0.55rem 1rem;
  border: 1px solid #e8e4df;
  border-radius: 16px;
  background: #fff;
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
  color: #4e3f3a;
}

.address-modal__apply {
  padding: 0.55rem 1.15rem;
  border: none;
  border-radius: 16px;
  background: #ff9702;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  cursor: pointer;
  color: #4e3f3a;
}

.address-modal__apply:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddressModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;;AAE/B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,iCAAiC;EACjC,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".address-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.address-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  border: none;\n  background: rgba(78, 63, 58, 0.45);\n  cursor: pointer;\n}\n\n.address-modal__suggestions {\n  list-style: none;\n  margin: 0 0 0.75rem;\n  padding: 0;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.address-modal__suggestion {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem 0.75rem;\n  border: none;\n  background: #faf8f6;\n  cursor: pointer;\n  font: inherit;\n}\n\n.address-modal__suggestion:hover {\n  background: #f0ebe6;\n}\n\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e8e4df;\n\n.address-modal__delivery-restaurants .cart__restaurant-sort-hint {\n  margin-bottom: 14px;\n}\n\n.address-modal__panel {\n  position: relative;\n  z-index: 1;\n  width: min(560px, 100%);\n  max-height: min(90vh, 720px);\n  overflow: auto;\n  background: #fff;\n  border: 2px solid #a78c83;\n  border-radius: 24px;\n  padding: 1rem 1.25rem 1.25rem;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n}\n\n.address-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.address-modal__title {\n  margin: 0;\n  font-family: 'Neucha', cursive;\n  font-size: 1.5rem;\n  font-weight: 400;\n  color: #4e3f3a;\n}\n\n.address-modal__close {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  background: transparent;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.address-modal__warn,\n.address-modal__hint,\n.address-modal__empty {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.8125rem;\n  margin: 0 0 0.5rem 0;\n}\n\n.address-modal__warn {\n  color: #991b1b;\n}\n\n.address-modal__hint {\n  color: #6b5d58;\n}\n\n.address-modal__hint--compact {\n  margin-top: 0.65rem;\n  margin-bottom: 0.35rem;\n  font-weight: 500;\n}\n\n.address-modal__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 0.75rem;\n  max-height: 200px;\n  overflow: auto;\n}\n\n.address-modal__row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n  width: 100%;\n  text-align: left;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  background: #fff;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.875rem;\n  color: #4e3f3a;\n  cursor: pointer;\n}\n\n.address-modal__row:hover {\n  background: #faf7f4;\n}\n\n.address-modal__row--active {\n  border-color: #ff9702;\n  background: #fff8ed;\n}\n\n.address-modal__row-text {\n  font-weight: 500;\n}\n\n.address-modal__row-meta {\n  font-size: 0.75rem;\n  color: #6b5d58;\n}\n\n.address-modal__badge {\n  font-size: 0.75rem;\n  color: #6b5d58;\n}\n\n.address-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 0.65rem;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.8125rem;\n  color: #4e3f3a;\n}\n\n.address-modal__field select,\n.address-modal__field textarea {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.875rem;\n  padding: 0.5rem 0.65rem;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  background: #fff;\n  color: #4e3f3a;\n}\n\n.address-modal__field textarea {\n  resize: vertical;\n  min-height: 52px;\n}\n\n.address-modal__secondary {\n  margin-bottom: 0.75rem;\n  padding: 0.45rem 0.75rem;\n  border: 1px solid #a78c83;\n  border-radius: 12px;\n  background: #f3e3cc;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.8125rem;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.address-modal__secondary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.address-modal__actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n}\n\n.address-modal__cancel {\n  padding: 0.55rem 1rem;\n  border: 1px solid #e8e4df;\n  border-radius: 16px;\n  background: #fff;\n  font-family: 'Roboto', sans-serif;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.address-modal__apply {\n  padding: 0.55rem 1.15rem;\n  border: none;\n  border-radius: 16px;\n  background: #ff9702;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.address-modal__apply:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
